(function () {
    'use strict';

    angular
        .module('invesfleet')
        .filter('initials', initialsFilter);

    function initialsFilter() {
        /*jshint maxcomplexity:false */
        return function (name) {
            if(name == null) { return '-'; }
            
            //var inls = name.split(' ') || [];

            var re = /[A-Za-z0-9][A-Za-z0-9]*/g;
            var inls = name.match(re);

            for (var i = 0; i < inls.length; i++) {
                inls[i] = inls[i][0];
            }

            if(inls == null) { return '-'; }
            
            inls = ((inls[0] || '') + (inls[1] || '')).toUpperCase();
            return inls;
        };
    }

})();